export enum QualityReservoir {
  BIBLIOTECA_GENERAL = 'CALIDAD_Biblioteca',
  SLIDER = 'CALIDAD_Slider',
  COMBUSTIBLE = 'CALIDAD_Combustibles',
  TOP_TIER = 'CALIDAD_TopTier',
  MATERIAL_CATEGORIAS = 'CALIDAD_Categorias_Material_Consulta',
  MATERIAL_ITEMS = 'CALIDAD_Material_Consulta',
  AXION_LAB = 'CALIDAD_AxionLabs',
  ACCESOS_ITEMS = 'CALIDAD_Accesos_de_Interes',
}
